var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-autocomplete", {
    attrs: {
      items: _vm.values,
      "item-text": "name",
      "item-value": "id",
      label: _vm.label,
      "return-object": "",
      "hide-details": "",
      clearable: "",
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v
      },
      expression: "value",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }